import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton, TableCell } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import EmailIcon from '@mui/icons-material/Email';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { connect } from 'react-redux';
import Swal from "sweetalert2";

import DefaultTable from '../../../components/Table';
import appConfig from '../../../config/appConfig';
import * as headerActions from '../../../store/actions/header';
import CreateHeaderConfiguration from './CreateHeaderConfiguration';
import EditHeaderConfiguration from './EditHeaderConfiguration';

const ViewHeaderConfigurations = ({ fetchHeaderConfigs, 
    resetEditHeaderConfigData, resetCreateHeaderConfigData, headerConfigs, deleteHeader }) => {

    const [activeMode, setActiveMode] = useState('list');
    const [headerConfigsData, setHeaderConfigsData] = useState();
    const [paginationHeader, setPaginationHeader] = useState({ limit: 10, offset: 1 });
    const [selectedRowHeader, setSelectedRowHeader] = useState();
    const [isHeaderConfigDeleted, setIsHeaderConfigDeleted] = useState(false);
    

    useEffect(async () => {
        await fetchHeaderConfigs(paginationHeader.limit, paginationHeader.offset);
    }, []);

    useEffect(() => {
        fetchHeaderConfigs(paginationHeader.limit, paginationHeader.offset);
    }, [paginationHeader, headerConfigs?.editHeaderData, headerConfigs?.createHeaderData])

    useEffect(() => {
        setHeaderConfigsData(headerConfigs?.headers?.headers);
    }, [headerConfigs])

    useEffect(() => {
        if (headerConfigs?.deleteHeaderData?.data?.status === 1 && isHeaderConfigDeleted) {
            setIsHeaderConfigDeleted(false);
            Swal.fire({
            icon: "success",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Header Configuration deleted successfully",
            });
            setTimeout(() => {
            fetchHeaderConfigs(paginationHeader.limit, 1,'','');
            }, 2000);
        }else if(headerConfigs?.deleteHeaderData?.data?.status === 0 && isHeaderConfigDeleted){
            setIsHeaderConfigDeleted(false);
            Swal.fire({
            icon: "error",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Error, please try again later",
            });
        }
    }, [JSON.stringify(headerConfigs?.deleteHeaderData)])

    const handlePaginationHeader = (limit, offset) => {
        setPaginationHeader({ limit, offset })
    }

    // const handleDefaultHeader = (row) => {
    //     console.log('Set payload and Update call', row);
    // }

    const handleEditHeader = (row) => {
        resetEditHeaderConfigData();
        setActiveMode('edit');
        setSelectedRowHeader(row);
    }

    const handleDeleteHeader = (row) => {
        const swalWithCustompButtons = Swal.mixin({
                customClass: {
                confirmButton: 'custom-ok-button',
                cancelButton: 'custom-cancel-button'
                },
                buttonsStyling: false
            })
        
            swalWithCustompButtons.fire({
                title: "",
                html: `Delete Header Configuration? <br/> <span style='font-size: 14px'}}> All Email configuration associated with this Header will be replaced by Default Header.</span>`,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Delete',
                reverseButtons: true
            }).then((result) => {
                setIsHeaderConfigDeleted(false);
                if (result.isConfirmed) {
                setIsHeaderConfigDeleted(true);
                deleteHeader(row);
                } else {
                setIsHeaderConfigDeleted(false);
                }
            })
    }

    const renderCellsHeader = (row) => {
        return <>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.defaultConfigFlag ? `${row.name}(Default)` : row.name}
            </TableCell>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.code}
            </TableCell>
        </>
    }

    const renderActionButtonHeader = (row) => {
        return <div className='display-flex'>
            {/* <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px' }}
                title={row?.isDefault ? 'Default Header Configuration' : 'Set as default'}
                aria-label={row?.isDefault ? 'default header configuration' : 'set as default header configuration'}
                size="small"
                onClick={() => {
                    handleDefaultHeader(row);
                }}
            >
                {
                    row?.isDefault ?
                        <EmailIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                        :
                        <MailOutlineIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                }
            </IconButton> */}
            <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Edit Header Configuration'
                aria-label="edit header configuration"
                size="small"
                onClick={() => {
                    handleEditHeader(row);
                }}
            >
                <ModeEditOutlineOutlinedIcon />
            </IconButton>
            {!row.defaultConfigFlag && <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Delete Header Configuration'
                aria-label="delete header configuration"
                size="small"
                onClick={() => {
                    handleDeleteHeader(row);
                }}
            >
                <DeleteForeverOutlinedIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
            </IconButton>}
        </div>
    }

    return <div>
        <Grid item md={12} xl={12} lg={12} sm={12} sx={{ mb: 1 }}>
            {
                activeMode === 'list' && 
                <DefaultTable
                    title='Header Configurations'
                    handlePagination={handlePaginationHeader}
                    headers={[
                        {
                            name: 'Name', sortEnabled: false
                        },
                        {
                            name: 'Code', sortEnabled: false
                        }
                    ]}
                    hasAction
                    renderActionButton={renderActionButtonHeader}
                    data={headerConfigsData}
                    totalCount={headerConfigsData?.length}
                    currentPage={paginationHeader.offset}
                    currentLimit={paginationHeader.limit}
                    renderCustomCells
                    renderCells={renderCellsHeader}
                    isTableHeaderEnabled
                    tableHeaderCallback={() => { resetCreateHeaderConfigData(); setActiveMode('create') }}
                    tableHeaderButtonText='Create Header Configurations'
                />
            }
            {
                activeMode === 'create' && 
                <CreateHeaderConfiguration 
                    showHeaderConfigurations={() => setActiveMode('list')} 
                />
            }
            {
                activeMode === 'edit' && 
                <EditHeaderConfiguration 
                    headerConfig={selectedRowHeader} 
                    showHeaderConfigurations={() => setActiveMode('list')} 
                />
            }
        </Grid>
    </div>
}

ViewHeaderConfigurations.propTypes = {
    headerConfigs: PropTypes.object.isRequired,
    fetchHeaderConfigs: PropTypes.func.isRequired,
    deleteHeader: PropTypes.func.isRequired,
    resetEditHeaderConfigData: PropTypes.func.isRequired,
    resetCreateHeaderConfigData: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
    headerConfigs: state.header,
})

const mapDispatchToProps = (dispatch) => {
    return {
        fetchHeaderConfigs: (limit, page) => dispatch(headerActions.getHeaderList(limit, page)),
        deleteHeader: (data) => dispatch(headerActions.deleteHeader(data)),
        resetEditHeaderConfigData: () => dispatch(headerActions.resetEditHeaderConfigData()),
        resetCreateHeaderConfigData: () => dispatch(headerActions.resetCreateHeaderConfigData()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewHeaderConfigurations);